















// vue
import {
    defineComponent,
    onMounted,
    onUnmounted,
    ref,
} from '@vue/composition-api';

// hooks
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';

// store
import { useStore } from '@/store';

// models
import { GeoRecord } from '@/vue3/api/models';

// turf
import * as turf from '@turf/turf';

export default defineComponent({
    props: {
        mapbox: {
            type: Object,
            default: () => {},
        },
        geoRecord: {
            type: Object,
            default: () => {},
        },
        saveGeoRecord: {
            type: Function,
            default: () => {},
        },
        activateCursor: {
            type: Function,
            default: () => {},
        },
        newCategoryDefaultId: {
            type: Number,
            default: 0,
        },
    },
    setup(props: any) {
        // model
        const newGeoRecord = ref({} as GeoRecord);

        // store
        const store = useStore();

        // hooks
        const { startDrawRectangle, removeCreateGeoRecordSource } =
            useGeoRecord();

        // refs
        const width = ref(0);
        const height = ref(0);
        const isMeters = store.state.isMeters;
        const noOfClick = ref(0);
        const isDrawing = ref(false);

        // methods
        const defaultParameters = () => {
            width.value = 0;
            height.value = 0;
            noOfClick.value = 0;
            isDrawing.value = false;
            newGeoRecord.value = {} as GeoRecord;
        };

        const handleKeyPress = async (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                resetFreehandRectangleValue();
                activateFreeDrawMode();
            }
        };

        const activateFreeDrawMode = () => {
            defaultParameters();

            props.activateCursor();

            removeCreateGeoRecordSource(props.mapbox.map);
            startDrawRectangle(props.mapbox.draw);
            props.mapbox.map.on('click', onMapClick);
        };

        const onMapClick = () => {
            noOfClick.value++;
            if (isDrawing) {    //Don't change to isDrawing.value
                if (noOfClick.value === 1) {
                    props.mapbox.map.on('mousemove', getDistanceFromStartPoint);
                }
                if (noOfClick.value === 2) {
                    newGeoRecord.value.geometry =
                        props.mapbox.draw.get('temp-rectangle').geometry;
                    props.mapbox.map.off('click', onMapClick);
                    getFreehandRectangleValue();
                }
            }
        };

        const getDistanceFromStartPoint = () => {
            var startPoint = turf.point(
                props.mapbox.draw.get('temp-rectangle').geometry
                    .coordinates[0][0],
            );

            var coordinateX = turf.point(
                props.mapbox.draw.get('temp-rectangle').geometry
                    .coordinates[0][1],
            );
            var coordinateY = turf.point(
                props.mapbox.draw.get('temp-rectangle').geometry
                    .coordinates[0][3],
            );

            var distanceToX =
                turf.distance(startPoint, coordinateX, {
                    units: 'miles',
                }) / 0.00062137;
            var distanceToY =
                turf.distance(startPoint, coordinateY, {
                    units: 'miles',
                }) / 0.00062137;

            width.value = parseInt(
                (distanceToX * (isMeters ? 1 : 1.09361)).toFixed(2),
            );
            height.value = parseInt(
                (distanceToY * (isMeters ? 1 : 1.09361)).toFixed(2),
            );
        };

        const getFreehandRectangleValue = () => {
            newGeoRecord.value.geometry =
                props.mapbox.draw.get('temp-rectangle').geometry;
            newGeoRecord.value.accountId = store.getters.account.id;
            newGeoRecord.value.courseSchemaId =
                store.getters.currentCourseSchema.id;
            newGeoRecord.value.organizationId =
                store.getters.currentOrganization.id;
            newGeoRecord.value.isFill = true;
            newGeoRecord.value.isRectangle = true;
            newGeoRecord.value.geoRecordCategoryId = props.newCategoryDefaultId;
            props.saveGeoRecord(newGeoRecord.value);
            removeCreateGeoRecordSource(props.mapbox.map);
            resetFreehandRectangleValue();
        };

        const resetFreehandRectangleValue = () => {
            defaultParameters();

            props.mapbox.draw.changeMode('simple_select');
            props.mapbox.draw.delete('temp-rectangle');
            props.mapbox.map.off('click', onMapClick);
            props.mapbox.map.off('mousemove', getDistanceFromStartPoint);
        };

        // lifecycle
        onMounted(() => {
            window.addEventListener('keydown', handleKeyPress);
        });

        onUnmounted(() => {
            window.removeEventListener('keydown', handleKeyPress);
        });

        return {
            width,
            height,
            isMeters,
            activateFreeDrawMode,
            onMapClick,
            resetFreehandRectangleValue,
        };
    },
});
